export default "__VITE_ASSET__ce784642__"